import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import { reducer as formsReducer } from 'redux-form';

import { ENVIRONMENT_CODE } from './common/Constants';
import { searchReducer } from './common/SearchStore/SearchReducer';
import userReducer from './common/UserStore/UserReducer';

const devToolsEnvironments = ['local', 'dev', 'qa'];

const appReducer = combineReducers({
  form: formsReducer,
  user: userReducer,
  search: searchReducer,
});

const rootReducer = (state, action) => {
  // For use when changing accounts and needing to reset store.
  let appState = state;
  switch (action.type) {
    default:
      appState = state;
  }

  return appReducer(appState, action);
};

export default function createAppStore(preloadedState) {
  const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false, // redux-form may have non-serializable values
      }),
    preloadedState,
    devTools: devToolsEnvironments.includes(ENVIRONMENT_CODE),
  });
  return store;
}
